// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__16Vcp","label":"LabeledBox_label__25Aut"};